import { useEffect, useState } from "react";
import { useUserGetAll } from "../../../fnx/user/userGetAll";
import { useDispatch } from "react-redux";
import { userClearData } from "../../../store/auth/actions";
import { useFiltersParser } from "./useFiltersParser";
import { formattedDate } from "../../../utils/date";
export var useUsersData = function (filtersApplied) {
    var dispatch = useDispatch();
    var _a = useState([]), usersData = _a[0], setUsersData = _a[1];
    var _b = useState(false), trigger = _b[0], setTrigger = _b[1];
    var _c = useState(1), page = _c[0], setPage = _c[1];
    var _d = useState(19), limit = _d[0], setLimit = _d[1];
    var _e = useState(0), countData = _e[0], setCountData = _e[1];
    var _f = useState(""), searchQuery = _f[0], setSearchQuery = _f[1];
    var filters = useFiltersParser(filtersApplied);
    useEffect(function () {
        setTrigger(true);
    }, []);
    useEffect(function () {
        setPage(1);
        setTrigger(true);
        setSearchQuery("");
    }, [filters]);
    useEffect(function () {
        if (searchQuery.length === 0 || searchQuery.length >= 3) {
            setTrigger(true);
        }
    }, [searchQuery]);
    var _g = useUserGetAll(trigger, page, limit, searchQuery, filters === null || filters === void 0 ? void 0 : filters.deleted, filters === null || filters === void 0 ? void 0 : filters.hasRole), responseUser = _g.responseUser, errorUser = _g.errorUser, loadingUser = _g.loadingUser, pagingInfo = _g.pagingInfo;
    useEffect(function () {
        if (responseUser) {
            var mappedUsers = responseUser.map(function (user) { return ({
                id: user.id,
                codeLabel: "Nombre: ",
                code: "".concat(user.name, " ").concat(user.lastName),
                typeLabel: "Usuario: ",
                type: user.userName,
                descriptionLabel: "Email: ",
                description: user.email,
                email: user.email,
                userName: user.userName,
                createdAt: formattedDate(user.createdAt || ""),
                fontSizeCode: 12,
                fontSizeDescription: 12,
                fontSizeType: 12,
                roles: user.roles,
                clientId: user.clientId,
                branchId: user.branchId,
                names: user.name,
                lastNames: user.lastName,
                enabled: String(user.enabled).toLowerCase() === "true"
                    ? "Habilitado"
                    : "Deshabilitado",
            }); });
            setUsersData(mappedUsers);
            setTrigger(false);
            if (pagingInfo) {
                setCountData(pagingInfo.totalItems);
            }
            dispatch(userClearData());
        }
    }, [responseUser]);
    return {
        usersData: usersData,
        loadingUser: loadingUser,
        errorUser: errorUser,
        countData: countData,
        setPage: setPage,
        page: page,
        setLimit: setLimit,
        limit: limit,
        callUsers: setTrigger,
        setSearchQuery: setSearchQuery,
    };
};
